import Icon from '../components/Icon.vue'

Icon.register({
  flask: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M437.2 403.5c29.3 47-4.4 108.5-60.1 108.5h-306.2c-55.6 0-89.4-61.4-60.1-108.5l117.2-188.5v-151h-8c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h208c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24h-8v151zM137.9 320h172l-48.2-77.6c-3.6-5.2-5.8-11.5-5.8-18.4v-160h-64v160c0 6.8-2.1 13.2-5.8 18.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/flask.js
// module id = 1364
// module chunks = 0